export const fncEmptyDepartments = (state, payload) => {
  state.departmentList = [];
}

export const setDepartmentalList = (state, payload) => {
  state.departmentList = payload;
}

export const setDepartmentRangesList = (state, payload) => {
  state.departmentRangesList = payload;
}

export const setObjDepartmentEdit = (state, payload) => {
  var editObj = [];
  for (var k in state.departmentList) {
    if (state.departmentList[k].id == payload.depId) {
      editObj = state.departmentList[k];
    }
  }

  var strRanges = [];

  for (var r in editObj.ranges) {
    strRanges.push(editObj.ranges[r].toString());
  }

  editObj.ranges = strRanges;
  state.objDepartmentEdit = editObj;

  /*for (var c in state.objDepartmentEdit.regionObj) {
    if (state.objDepartmentEdit.regions.indexOf(state.objDepartmentEdit.regionObj[c].loc_id) > -1) {
      console.log(state.objDepartmentEdit.regionObj[c].name );
      state.objDepartmentEdit.regionObj[c].selected = true;
    }
    for (var p in state.objDepartmentEdit.regionObj[c].children) {
      if (state.objDepartmentEdit.regions.indexOf(state.objDepartmentEdit.regionObj[c].children[p].loc_id)) {
        state.objDepartmentEdit.regionObj[c].children[p].selected = true;
      }
      for (var t in state.objDepartmentEdit.regionObj[c].children[p].children) {
        if (state.objDepartmentEdit.regions.indexOf(state.objDepartmentEdit.regionObj[c].children[p].children[t].loc_id)) {
          state.objDepartmentEdit.regionObj[c].children[p].children[t].selected = true
        }
      }
    }
  }
  state.userRegions = state.objDepartmentEdit.regionObj;*/
}

export const fncSetProductCodes = (state, payload) => {
  state.productCodes = payload;
}

export const setDepartmentUsers = (state, payload) => {
  state.departmentUsers = payload;
}

export const setDepartmentStatuses = (state, payload) => {
  state.departmentStatuses = payload;
}

export const setDepartmentLoader = (state, payload) => {
  state.departmentLoader = payload;
}

export const setDepartmentUsedRanges = (state, payload) => {
  if (payload == null || payload == 'null' || payload == '') {
    state.departmentUsedRanges = [];
  } else {
    state.departmentUsedRanges = payload.split(',');
  }
  var selectableRanges = [];
  for (var d in state.departmentRangesList) {
    if (state.departmentUsedRanges.indexOf(state.departmentRangesList[d].id32) == -1) {
      selectableRanges.push(state.departmentRangesList[d]);
    }
  }
  state.departmentRangesList = selectableRanges;
}

export const setUserBranchesDepartments = (state, payload) => {
  state.userBranchesDepartments = payload;
}

export const fncSetLookupArray = (state, payload) => {
  state.lookupArray = payload;
}
